import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { ArrowUpRight } from 'lucide-react';

export default function ProyectosSection() {
  const [items, setItems] = useState([]);
  const [cfg, setCfg] = useState({ wordpress: '' });

  useEffect(() => {
    api.get('/projects?limit=6').then(r => setItems(r.data)).catch(() => setItems([]));
    api.get('/blog/config').then(r => setCfg(r.data)).catch(() => {});
  }, []);

  if (items.length === 0) return null;
  const allUrl = cfg.wordpress ? `${cfg.wordpress.replace(/\/$/, '')}/proyectos/` : '';

  return (
    <section className="mt-32 lg:mt-40 max-w-[1400px] mx-auto px-6 lg:px-12" data-testid="proyectos-section">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end mb-12">
        <div className="md:col-span-7">
          <p className="overline">Proyectos</p>
          <h2 className="font-serif text-5xl lg:text-6xl mt-4 leading-[1.05] font-light">
            Casas que <em className="italic font-light">hemos diseñado</em>.
          </h2>
        </div>
        <div className="md:col-span-5">
          <p className="text-stilo-ink2 leading-relaxed">Una selección de proyectos del estudio. Cada hogar tiene su carácter, su luz y su historia.</p>
          {allUrl && (
            <a href={allUrl} target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-2 mt-6 text-sm tracking-[0.22em] uppercase border-b border-stilo-ink hover:text-stilo-gold hover:border-stilo-gold transition-colors pb-1"
              data-testid="proyectos-all">
              Ver todos los proyectos <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
            </a>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-12">
        {items.slice(0, 6).map((p, i) => (
          <a key={p.id} href={p.link} target="_blank" rel="noreferrer" className="group" data-testid={`proyecto-${i}`}>
            <div className="relative bg-stilo-stone aspect-[4/5] overflow-hidden">
              {p.image
                ? <img src={p.image} alt="" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
                : <div className="w-full h-full bg-stilo-beige" />}
            </div>
            <h3 className="font-serif text-2xl mt-5 leading-tight group-hover:text-stilo-gold transition-colors">{p.title}</h3>
            <span className="inline-flex items-center gap-1 mt-3 text-xs tracking-[0.22em] uppercase text-stilo-ink2 group-hover:text-stilo-gold">
              Ver proyecto <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.5} />
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}
